import { render, staticRenderFns } from "./ReviewNextSteps.vue?vue&type=template&id=2a377b71&scoped=true"
import script from "./ReviewNextSteps.vue?vue&type=script&lang=js"
export * from "./ReviewNextSteps.vue?vue&type=script&lang=js"
import style0 from "./ReviewNextSteps.vue?vue&type=style&index=0&id=2a377b71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a377b71",
  null
  
)

export default component.exports